import React from 'react'

import {ProjectSystemType} from "../../../../../core/model2/project/types"
import AppQuickAdd from "../../../quick-add"
import GroupFromLocalTemplate from "../form/from-local-template/group"
import QuickAdd_BreadcrumbNavigation from "../../../layout/page-title/form-title-breadcrumb"
import {BreadcrumbElement} from "../../../../../core/gd-components/breadcrumbs/breadcrumbs-custom"
import {QuickAddBreadcrumbElement} from "../../../@types"

type Props = {
    app                 : AppQuickAdd
    initParams          : any

    templateId          : ID

    onSelectType        : {(type: any, templateId?: ID): void}
    onProjectCreated?   : func
}

// const debug = "NewProject_AddFromTemplate"
const debug = false

export default function NewProject_AddFromTemplate(props: Props) {

    const template = gd.session.templatesList.get(props.templateId)
    let AddForm

    debug && console.log(debug, 'renderAddFromTemplate', template.systemType)

    switch (template.systemType){
        case ProjectSystemType.FOLDER   : AddForm = require('../form/from-local-template/workfolder'); break
        case ProjectSystemType.PROJECT  : AddForm = require('../form/from-local-template/project'); break
        case ProjectSystemType.SPRINT   : AddForm = require('../form/from-local-template/sprint'); break
        case ProjectSystemType.BACKLOG  : AddForm = require('../form/from-local-template/backlog'); break
        case ProjectSystemType.CATEGORY : AddForm = GroupFromLocalTemplate; break
    }

    const breadcrumbItems: BreadcrumbElement[] = [
        QuickAddBreadcrumbElement.PROJECT_RESOURCES,
        {
            label: template.name
        }
    ]

    return (
        <div className={Classes("new-main","new-form","project")}>
            <QuickAdd_BreadcrumbNavigation breadcrumbItems={breadcrumbItems}/>
            <div className="quick-add-content m-t-35">
                <AddForm app                = {props.app}
                         initParams         = {props.initParams}
                         template           = {template}
                         onProjectCreated   = {props.onProjectCreated}/>
            </div>
        </div>
    )
}
